"use client";

import React from "react";
import s from "../styles";
import logjs from "@metrojs/logjs";
const log = new logjs("HassouInfoArea");

export default function HassouInfoArea({ data, isY_6_4, isY_7_2, btflg }) {
  // 表示モード判定（Cake: reqorder_comp または complete && btflg==1）
  const showFull = !!(isY_6_4 || (isY_7_2 && btflg === 1));

  // 発注元（requestinfo.ctp の取得優先に合わせて埋める）
  const hacchusaki = {
    corpName: data?.hacchusaki_corp,
    zip: data?.request?.ZipCode,
    addr: data?.request?.Todofuken + data?.request?.Jyusho1 + data?.request?.Jyusho2 + data?.request?.Jyusho3,
    tel: data?.request?.Tel,
    tando: data?.request?.UserName,
  };

  log.debug("HassouInfoArea ------ data:", data);
  // 発送先（詳細表示で使う項目）
  const hassoData = {
    corpName: data?.hassoData?.CorpName,
    zip: data?.hassoData?.ZipCode,
    address: data?.hassoData?.Address,
    tel: data?.hassoData?.Tel,
    tanto: data?.hassoData?.Tando,
  };

  // Cake の背景色ロジック: 発注元と発送先が異なる（Hassosaki_Corp がある）と濃い色
  const hasHassosakiCorp = !!data?.request?.Hassosaki_Corp;
  const bgColor = hasHassosakiCorp ? "#ffff99" : "#fffff0";

  // 簡易表示で使う都道府県（発注元=CO or 発送先=Hassosaki）
  log.debug("hAddr ------ data:", data);
  const hTodo = !hasHassosakiCorp ? (data?.request?.Todofuken ?? "") : (data?.request?.Hassosaki_Todofuken ?? "");
  const hAddr = () => {
    let _addr = "";
    if (hTodo === "北海道" || hTodo === "沖縄県" || hTodo === "京都府" || hTodo === "香川県" || data?.request?.ritou_flg === 1) {
      if (!hasHassosakiCorp) {
        _addr = data?.request?.Jyusho1;
        if (_addr && _addr.includes("市")) {
          _addr = _addr.substring(0, _addr.indexOf("市") + 1);
        } else {
          _addr = _addr.substring(0, 3);
        }
      } else {
        _addr = data?.request?.Hassosaki_Address;
        if (_addr && _addr.includes("市")) {
          _addr = _addr.substring(0, _addr.indexOf("市") + 1);
        } else {
          _addr = _addr.substring(0, 3);
        }
      }
    }
    return _addr;
  }

  // 離島・道県注意（元実装の一部: 北海道/沖縄/京都/香川 + 一部離島判定は簡略） PHPの実装方法に揃える 26/04/27 masami
  //const showSimpleNotice = hTodo === "北海道" || hTodo === "沖縄県" || hTodo === "京都府" || hTodo === "香川県";
  const isRitouFlg = () => {
    if (data?.request?.ritou_flg === 1) {
      return true;
    }
    let _addr = "";
    if (!hasHassosakiCorp) {
      _addr = data?.request?.Jyusho1;
      if (_addr && _addr.includes("小豆郡")) {
        return true;
      }
    } else {
      _addr = data?.request?.Hassosaki_Address;
      if (_addr && _addr.includes("小豆郡")) {
        return true;
      }
    }
    return false;
  };
  
  
  log.debug(`showFull: ${showFull}, hTodo: ${hTodo}`, hacchusaki);
  return (
    <>
      {showFull && (hacchusaki.corpName || hacchusaki.zip || hacchusaki.addr || hacchusaki.tel || hacchusaki.tando) && (
        <s.DetailTable>
          <s.DetailCaption>発注元</s.DetailCaption>
          <tbody>
            <tr>
              <s.DetailTh scope="row">会社名</s.DetailTh>
              <s.DetailTd>{hacchusaki.corpName}</s.DetailTd>
              <s.DetailTh>郵便番号</s.DetailTh>
              <s.DetailTd>{hacchusaki.zip}</s.DetailTd>
            </tr>
            <tr>
              <s.DetailTh scope="row">住所</s.DetailTh>
              <s.DetailTd colSpan={3}>{hacchusaki.addr}</s.DetailTd>
            </tr>
            <tr>
              <s.DetailTh scope="row">電話番号</s.DetailTh>
              <s.DetailTd>{hacchusaki.tel}</s.DetailTd>
              <s.DetailTh>担当者名</s.DetailTh>
              <s.DetailTd>{hacchusaki.tando ? `${hacchusaki.tando}様` : ""}</s.DetailTd>
            </tr>
          </tbody>
        </s.DetailTable>
      )}

      {showFull ? (
        <s.DetailTable>
          <s.DetailCaption>
            発送先
            <s.NoticeText>※商品はこちらへ発送をお願いします。</s.NoticeText>
          </s.DetailCaption>
          <tbody>
            <tr>
              <s.DetailTh scope="row">会社名</s.DetailTh>
              <s.DetailTd style={{ backgroundColor: bgColor, fontWeight: "bold", fontSize: "15px" }}>{hassoData.corpName}</s.DetailTd>
              <s.DetailTh>郵便番号</s.DetailTh>
              <s.DetailTd style={{ backgroundColor: bgColor, fontWeight: "bold", fontSize: "15px" }}>{hassoData.zip}</s.DetailTd>
            </tr>
            <tr>
              <s.DetailTh scope="row">住所</s.DetailTh>
              <s.DetailTd colSpan={3} style={{ backgroundColor: bgColor, fontWeight: "bold", fontSize: "15px" }}>
                {hassoData.address}
              </s.DetailTd>
            </tr>
            <tr>
              <s.DetailTh scope="row">電話番号</s.DetailTh>
              <s.DetailTd style={{ backgroundColor: bgColor, fontWeight: "bold", fontSize: "15px" }}>{hassoData.tel}</s.DetailTd>
              <s.DetailTh>担当者名</s.DetailTh>
              <s.DetailTd style={{ backgroundColor: bgColor, fontWeight: "bold", fontSize: "15px" }}>{hassoData.tanto ? `${hassoData.tanto}様` : ""}</s.DetailTd>
            </tr>
          </tbody>
        </s.DetailTable>
      ) : (
        <s.DetailTable>
          <s.DetailCaption>発送先</s.DetailCaption>
          <tbody>
            <tr>
              <s.DetailTh scope="row" style={{ textAlign: "right" }}>
                都道府県名
              </s.DetailTh>
              <s.DetailTd>
                {hTodo}{hAddr() ? ` ${hAddr()}` : ""}
                {isRitouFlg() && <s.WarningText>(ご回答いただく際、送料の金額にご注意ください。)</s.WarningText>}
              </s.DetailTd>
            </tr>
          </tbody>
        </s.DetailTable>
      )}
    </>
  );
}
